import { SectionTypes } from 'bundles/university-program-qualification/utils/constants';

const { TERMINAL, QUESTION } = SectionTypes;

// Define the types for Destination and Recommendation objects
type Destination = {
  [key: string]: unknown;
};

type Recommendation = {
  typeName: string;
};

const SurveyUtils = {
  /**
   * Get the section type of a given destination object.
   * @param {Destination} destination - The destination object to check for section type.
   * @returns {string | undefined} The section type (TERMINAL or QUESTION) if found, or undefined otherwise.
   */
  getSectionType(destination: Destination): string | undefined {
    if (TERMINAL in destination) {
      return TERMINAL;
    } else if (QUESTION in destination) {
      return QUESTION;
    } else {
      return undefined;
    }
  },

  /**
   * Get the recommendation type of a given recommendation object.
   * @param {Recommendation} recommendation - The recommendation object to get the type for.
   * @returns {string} The recommendation type name.
   */
  getRecommendationType(recommendation: Recommendation): string {
    return recommendation.typeName;
  },
};

export default SurveyUtils;

export const { getSectionType, getRecommendationType } = SurveyUtils;
